export default __webpack_public_path__ + "static/media/ies_AcercaDe_ENG.0b31bd54.png";